import cn from 'classnames';
// import { HowToJsonLd } from 'next-seo';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useMemo, useState } from 'react';
// import required modules
import type SwiperCore from 'swiper';
import { Thumbs } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import Button from '@/components/Button';
import { generateDeepLinkByPathname } from '@/lib/common';
import { placeholderImageUrl } from '@/lib/constants';
import useIsMobile from '@/lib/useIsMobile';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';

type Items = {
  step: string;
  desc: string;
  urlImage: string;
};

type Props = {
  items: Items[];
  delivery?: boolean;
  title?: string;
  className?: string;
};

export default function InstructionContent({
  items,
  delivery = false,
  title,
  className,
}: Props) {
  const { pathname } = useRouter();
  const isMobile = useIsMobile();
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperCore>();

  const instructTitle = useMemo(() => {
    if (title) return title;

    if (delivery) {
      return 'Hướng dẫn sử dụng dịch vụ giao hàng';
    }
    return 'Hướng dẫn sử dụng dịch vụ xe tải';
  }, [title, delivery]);

  // const howToImage = useMemo(() => {
  //   if (delivery) {
  //     return baseUrl + '/static/images/service/banner-delivery-desktop.webp';
  //   }
  //   return baseUrl + '/static/images/service/banner-truck-desktop.webp';
  // }, [delivery]);

  return (
    <section className={cn('bg-primary-10 py-20', className)}>
      {/* <HowToJsonLd
        name={title}
        image={howToImage}
        // estimatedCost={{ currency: 'USD', value: '100' }}
        // supply={[]}
        tool={['Ứng dụng Ahamove', 'Website app.ahamove.com']}
        // totalTime="P2D"
        step={items.map((item) => ({
          url:
            `${baseUrl}` +
            (asPath === '/' ? '' : asPath.split('#')[0].split('?')[0]),
          name: item.step,
          itemListElement: [
            {
              type: 'HowToDirection',
              text: item.desc,
            },
          ],
          image: baseUrl + item.urlImage,
        }))}
      /> */}
      <div className="max-w-8xl desktop:px-8 mx-auto px-4">
        <div className="desktop:grid-cols-2 desktop:gap-12 grid grid-cols-1 place-content-center items-center gap-6">
          {isMobile ? (
            <h2 className="text-title32 text-neutral-90 desktop:text-left desktop:text-title42 desktop:hidden text-center font-bold">
              {instructTitle}
            </h2>
          ) : null}
          <Swiper
            slidesPerView={1}
            slidesPerGroup={1}
            spaceBetween={10}
            watchOverflow={true}
            thumbs={{
              swiper:
                thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
            }}
            modules={[Thumbs]}
            className="w-full"
          >
            {items.map((item) => (
              <SwiperSlide key={item.step}>
                <div
                  className={cn('relative mx-auto w-full', {
                    'aspect-[311/410]': delivery,
                    'desktop:w-3/4 aspect-[4/7]': !delivery,
                  })}
                >
                  <Image
                    src={item.urlImage || placeholderImageUrl}
                    alt={item.desc}
                    objectFit="contain"
                    fill
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="desktop:items-start desktop:w-auto mx-auto flex w-full flex-col justify-center space-y-10">
            {!isMobile ? (
              <h2 className="text-title32 text-neutral-90 desktop:text-left desktop:text-title42 desktop:block hidden text-center font-bold">
                {instructTitle}
              </h2>
            ) : null}
            <Swiper
              onSwiper={setThumbsSwiper}
              direction={isMobile ? 'horizontal' : 'vertical'}
              slidesPerView={isMobile ? 1 : items.length}
              spaceBetween={0}
              slidesPerGroup={isMobile ? 1 : items.length}
              freeMode={true}
              watchSlidesProgress={true}
              modules={[Thumbs]}
              className="gallery-thumbs w-swiper-mobile desktop:h-fit desktop:w-full"
            >
              {items.map((item) => (
                <SwiperSlide
                  className="desktop:pl-6 group flex min-h-[118px] flex-col items-start justify-center rounded-lg p-4"
                  key={item.step}
                >
                  <div
                    className="list-inside list-disc"
                    style={{
                      display: 'list-item',
                    }}
                  >
                    <h3 className="text-subtitle20 group-hover:text-primary-50 inline-block text-left font-bold active:hover:!text-white">
                      {item.step}
                    </h3>
                  </div>
                  <p className="text-subtitle18 ml-5 text-left font-normal">
                    {item.desc}
                  </p>
                </SwiperSlide>
              ))}
            </Swiper>
            <Button
              type="link"
              title="Lên đơn ngay!"
              href={
                generateDeepLinkByPathname(pathname) ||
                'https://app.ahamove.com/'
              }
            >
              Lên đơn ngay
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
